import { useEffect, useState } from 'react'
import _ from 'lodash'
import { Input, Autocomplete } from '@design-systems/canvas-ui'
import { isValidPhoneNumber } from 'mvscommoncomponents'

const PhoneNumberInput = (props) => {
  const [countryCode, setCountryCode] = useState(null)
  const [phoneNumber, setPhoneNumber] = useState(null)

  useEffect(() => {
    setCountryCode(props.countryCode)
  }, [props.countryCode])

  useEffect(() => {
    setPhoneNumber(props.phoneNumber)
  }, [props.phoneNumber])

  useEffect(() => {
    if (
      (countryCode?.length >= 0 &&
        !_.isEqual(props.countryCode, countryCode)) ||
      (phoneNumber?.length >= 0 && !_.isEqual(props.phoneNumber, phoneNumber))
    ) {
      props.updateCountryPhoneNumber(countryCode, phoneNumber)
    }
  }, [countryCode, phoneNumber]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="row-top width-100">
      <Autocomplete
        className="height-32p lcm-autocomplete-control"
        key="ac-phone-country-code"
        options={(props.options || []).map((o) => ({
          ...o,
          id: String(o.id ?? o.value ?? o.label),
        }))}
        data-testid="ac-phone-country-code"
        onChange={(value) => {
          let newCountryCode = value?.value ?? ''
          setCountryCode(newCountryCode)
        }}
        value={countryCode ? String(countryCode) : ''}
        placeholder={'Please select country code'}
        openOnFocus
      />

      <Input.Text
        key="tb-phone-number"
        className="hc8-ml-2x"
        value={phoneNumber}
        onChange={(event) => {
          let newPhoneNumber = event.target.value

          newPhoneNumber =
            newPhoneNumber === '' || isValidPhoneNumber(newPhoneNumber)
              ? newPhoneNumber
              : phoneNumber
                ? phoneNumber
                : ''
          setPhoneNumber(newPhoneNumber)
        }}
      />
    </div>
  )
}

export default PhoneNumberInput
